import Cookies from 'js-cookie';
import { callAPI } from '..';
import { apiPath } from '..';
import moment from 'moment';

// Louis 2024-07-13 將getToken獨立開來
const getToken = async () => {

    let token = null;

    try {
        const url = apiPath.GET_URL_TOKEN;
        const method = 'GET';
        const response = await callAPI({ method, url });
        const httpCode = response.status || -1;

        console.log("GET_URL_TOKEN response;");
        console.log(response.data);

        // 檢查 HTTP 狀態碼和回應數據的狀態
        if (httpCode === 200) {

            let payload = null;
            // 檢查是否為JSON Object;
            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            if (payload && payload.status === 0 && payload.errorCode === '0000') {

                token = payload.data.token;
                const timestamp = payload.data.timestamp;
                const expireDate = payload.data.expireDate;
                // 檢查 timestamp 是否為有效日期
                const expirationDate = new Date(timestamp);
                // moment(timestamp).format("YYYY-MM-DD HH.mm.ss.SSSSSS");
                // 設置 Cookies
                if (Cookies.get('cookieConsent') === 'accepted') {
                    Cookies.set('Token', token, { expires: expirationDate });
                    Cookies.set('TokenExpiration', expireDate.toString(), { expires: expirationDate });
                } else {

                }
            }

        } else if (httpCode !== -1) {

            // 處理其他錯誤
            alert(`網站遇到錯誤 - HTTP 狀態碼: ${httpCode}`);

        } else {

            console.error('API 未執行:', url);

        }
    } catch (error) {

        console.error('Error:', error);

    }

    return token;

}

const tokenInfo = async (checkToken) => {

    let currentToken = checkToken;
    let isValid = false;
    let resultPayload = {};

    if (currentToken != null && currentToken.length > 0) {

        // 表示目前的token存在; 向主機查詢狀態;

        let headers = {
            token: currentToken
        };

        try {
            const url = apiPath.GET_URL_TOKEN_INFO;
            const method = 'GET';
            const response = await callAPI({ method, url, headers });
            const httpCode = response.status || -1;

            console.log("GET_URL_TOKEN_INFO response;");
            console.log(response.data);

            // 檢查 HTTP 狀態碼和回應數據的狀態
            if (httpCode === 200) {

                let payload = null;
                // 檢查是否為JSON Object;
                if (typeof response.data === 'string') {

                    payload = JSON.parse(response.data);
                } else {
                    payload = response.data;
                }

                if (payload && payload.status === 0) {


                    isValid = true;
                    resultPayload.data = payload.data;


                    console.log("Token check: true!!");
                    console.log("payload.data: ");
                    console.log(payload.data);

                    // 檢查 cookie 是否被接受
                    if (Cookies.get('cookieConsent') === 'accepted') {
                        //TopBar引導頁會用到，減少跳轉，沒有保存到就多跳轉一次
                        Cookies.set('isLogin', payload?.data?.isLogin === true);
                    }
                }

            } else if (httpCode !== -1) {

                // 處理其他錯誤
                alert(`網站遇到錯誤 - HTTP 狀態碼: ${httpCode}`);

            } else {

                console.error('API 未執行:', url);

            }
        } catch (error) {

            console.error('Error:', error);

        }

    }

    resultPayload.isValid = isValid;

    return resultPayload;

}

const getCookieToken = async () => {

    console.log("getCookieToken start!");
    let checkToken = null;

    // 檢查 cookie 是否被接受
    if (Cookies.get('cookieConsent') === 'accepted') {

        // 獲取 Token 的值
        checkToken = Cookies.get('Token');

        // 如果 Token 不存在或是空值，發起 API 請求
        if (!checkToken || checkToken.trim() === '') {

            console.log("Token is not in cookies");
            checkToken = await getToken();
            console.log("feedback token:" + checkToken);
        }

        return checkToken;

    } else {

        // 沒有同意 Cookie 的情況
        return null;
    }
};

export { getCookieToken, tokenInfo, getToken };
